export default __webpack_public_path__ + "static/media/SAS Alert Tone 6.a21dd418.mp3";